export default __webpack_public_path__ + "static/media/1.2.0.eb037b39.yaml";